import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "inherit",
      d: "M7.668 5.833a5.2 5.2 0 0 0-1.516-.5 2.5 2.5 0 1 0-1.797 0A5.25 5.25 0 0 0 0 10.493a1 1 0 0 0 1 1h8.5a1 1 0 0 0 1-1 5.23 5.23 0 0 0-2.832-4.66M5.25 2.493a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-3.092 7a3.25 3.25 0 0 1 3.092-2.25 3.2 3.2 0 0 1 1.5.362 3.25 3.25 0 0 1 1.595 1.888z",
      class: "fill-primary"
    }, null, -1),
    _createElementVNode("path", {
      fill: "inherit",
      d: "M11.645 9.575a2.5 2.5 0 1 0-1.79 0A5.25 5.25 0 0 0 5.5 14.743a1 1 0 0 0 1 1H15a1 1 0 0 0 1-1 5.25 5.25 0 0 0-4.355-5.168m-.895-2.832a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-3.093 7a3.25 3.25 0 0 1 6.185 0z",
      class: "fill-secondary"
    }, null, -1)
  ])))
}
export default { render: render }